import type { ReactNode } from 'react';

import { formatMillisecondsToDateWithApostrophe } from '@shared/helpers/date';
import { formatNumberLocalized } from '@shared/helpers/formatters';

import { Typography } from '@ui/uikit/components/common/Typography';

interface PredictionCellProps {
  icon: ReactNode;
  roundNumber: number;
  timestamp: number;
}

export const PredictionCell = ({ icon, roundNumber, timestamp }: PredictionCellProps) => {
  const formattedRoundName = `BNB/USDT #${formatNumberLocalized(roundNumber)}`;
  const formattedTimestamp = formatMillisecondsToDateWithApostrophe(timestamp, { hasTime: true });

  return (
    <div
      // TODO: find better solution to make ellipsis and avoid max-w-[calc(100vw_-_32px)]
      className="flex gap-4 xl-msq:gap-0 xl-msq:flex-col max-w-[calc(100vw_-_32px)]"
      title={`${formattedRoundName} ${formattedTimestamp}`}
    >
      <div className="flex gap-2">
        {icon && icon}
        <Typography variant="caption-s-strong" isEllipsis noWrap title={formattedRoundName}>
          {formattedRoundName}
        </Typography>
      </div>
      <Typography variant="caption-s" color="tertiary" isEllipsis noWrap title={formattedTimestamp}>
        {formattedTimestamp}
      </Typography>
    </div>
  );
};
